import React, {Component} from 'react';
import 'react-router/Router';
import nl2br from 'react-nl2br';
import logo from '../assets/logo.svg';
import 'whatwg-fetch';
import moment from 'moment';
import NotFound from "./NotFound";
import Loader from "./Loader";
import DeliveryPhotos from "./DeliveryPhotos";
import Map from "./Map";

class TrackWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {tracking_ref: this.props.match.params.reference, status: 'loading'};
        this.logoClick = this.logoClick.bind(this);
    }

    componentDidMount(){ this._updateState() }
    componentWillReceiveProps(){ this._updateState() }
    _updateState(){
        fetch(`${process.env.REACT_APP_API_URL}transactions/${this.state.tracking_ref}`).then((response) => {
            if(response.status === 404) {
                alert('Transaction not found. Please try again.');
                this.props.history.push('/');
            } else if(response.status !== 200) {
                alert('An error occured. Please try again later.');
                this.props.history.push('/');
            }
            return response.json();
        }, (error) => {
            console.error(`API Error: ${error}`);
        }).then((json) => {
            if(json.data) {
                this.setState(json.data);
                this.setState({ status: 'success' });
            } else if(json.error) {
                console.log(json);
                this.setState({ status: 'error' });
            }
        });
    }

    logoClick(event) {
        event.preventDefault();
        this.props.history.push('/');
    }

    translation(string) {

        const phrases = {
            'Type': {
                'delivery': 'Delivery',
                'collection': 'Collection',
            },
            'typed': {
                'delivery': 'delivered',
                'collection': 'collected',
            },
            'typed at': {
                'delivery': 'delivered to',
                'collection': 'collected from',
            },
            'drop number': {
                'delivery': 'Delivery Drop Number',
                'collection': 'Collection Stop',
            },
        };

        return phrases[string][this.state.type];

    }

    render() {

        return (
            <main className="main track">
                <img src={logo} alt="THX Stream" className="app-logo img-fluid" onClick={this.logoClick} />
                { this.renderStates() }
            </main>
        );
    }

    renderStates() {
        if(this.state.status === 'loading') {
            return (<Loader />);
        } else if(this.state.id > 0) {

            const tracking_number = (
                <h2 className="reference">Tracking No. {this.state.tracking_ref}</h2>
            );

            const table = (
                <table className="block">
                    <tbody>
                    <tr>
                        <th>{this.translation('Type')} Date</th>
                        <td>{moment(this.state.expected_at).format('Do MMMM YYYY')}</td>
                    </tr>
                    {this.state.customer_ref &&
                    <tr>
                        <th>Customer Reference</th>
                        <td>{this.state.customer_ref}</td>
                    </tr>
                    }
                    <tr>
                        <th>THX Order Number</th>
                        <td>{this.state.contract_id}</td>
                    </tr>
                    </tbody>
                </table>
            );

            if(this.state.completed_at) {

                let proofLine = '';
                if(this.state.media.photo && this.state.media.photo.length > 0) {
                    proofLine = (
                        <h3>Signature and Photo Proof of delivery:</h3>
                    );
                }
                let signature = '';
                if(this.state.media.signature || this.state.signed_by) {
                    let signature_image = '';
                    let signed_by = '';

                    if(this.state.media.signature) {
                        signature_image = (
                            <img src={this.state.media.signature.full} className="img-fluid" alt="Signed by" />
                        );
                    }
                    if(this.state.signed_by) {
                        signed_by = (
                            <h4 className="my-1">Signed by: <span>{this.state.signed_by}</span></h4>
                        );
                    }

                    signature = (
                        <figure className="signature mt-2 mx-3 mb-0">
                            {signature_image}
                            {signed_by}
                        </figure>
                    );
                }

                let gallery = '';
                if(this.state.media.photo) {
                    gallery = (
                        <DeliveryPhotos photos={this.state.media.photo} />
                    );
                }

                let window = '';
                if(proofLine || signature) {
                    window = (
                        <section className="window">
                            {proofLine}
                            {signature}
                        </section>
                    );
                }

                let download = '';
                if(this.state.completed_at) {
                    download = (
                        <section className="window download">
                            <p>You can download a PDF of this page to save offline.</p>
                            <a href={`${process.env.REACT_APP_API_URL}stream-report/${this.state.tracking_ref}`} className="btn btn-primary">Download PDF</a>
                        </section>
                    );
                }

                let notes = '';
                console.log(this.state.notes);
                if(this.state.notes) {
                    notes = (
                        <section className="notes">
                            <h4>{this.translation('Type')} Notes</h4>
                            <p>{nl2br(this.state.notes)}</p>
                        </section>
                    );
                }


                return (
                    <div>
                        <div className="card">
                            {tracking_number}
                            {table}
                            <div className="block">
                                <h3>Your items were {this.translation('typed at')} -<br />{this.state.address}</h3>
                            </div>
                            <div className="driver block">
                                <div className="thumbnail"><img src={this.state.driver_photo} className="img-fluid" alt={this.state.driver_name} /></div>
                                <div className="name">
                                    <h3>
                                        {this.state.driver_name} {this.translation('typed')} your items at {moment(this.state.completed_at).format('HH:mma')} on {moment(this.state.completed_at).format('ddd Do MMMM')}
                                    </h3>
                                </div>
                            </div>
                            {notes}
                            <a href={`https://thxuk.com/meet-the-team/?person=${this.state.driver_name}&orderid=${this.state.contract_id}&source=stream`}><div className="btn btn-white">Leave Feedback</div></a>
                        </div>
                        {window}
                        {gallery}
                        {download}
                    </div>
                );
            }

            return (
                <div>
                    <div className="card">
                        {tracking_number}
                        {table}
                        <div className="block">
                            <h3>{this.translation('Type')} Address -<br />{this.state.address}</h3>
                        </div>
                        <div className="driver block">
                            <div className="thumbnail"><img src={this.state.driver_photo} className="img-fluid" alt={this.state.driver_name} /></div>
                            <div className="name">
                                <h3>Your driver for this {this.translation('Type').toLowerCase()} is {this.state.driver_name}</h3>
                            </div>
                        </div>
                    </div>
                    <section className="window">
                        <h3>
                            Estimated {this.translation('Type').toLowerCase()} window:<br />
                            {moment(this.state.expected_at).format('ddd')} {moment(this.state.expected_at).subtract(30, 'minutes').format('HH:mma')}-{moment(this.state.expected_at).add(1, 'hour').add(30, 'minutes').format('HH:mma')}
                        </h3>
                        <h3>{this.translation('drop number')} {this.state.drop} of {this.state.drop_total}</h3>
                    </section>

                    <Map address={this.state.address} vehicle_id={this.state.vehicle_id} driver_name={this.state.driver_name} />
                </div>
            );
        }
        return (<NotFound tracking_ref={this.state.tracking_ref}/>);
    }
}

export default TrackWrapper;



// WEBPACK FOOTER //
// ./src/components/TrackWrapper.js